<template>
  <TextInput
    :id="$attrs.id || 'name'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'name'"
    :label="$attrs.label || 'Nome completo'"
    :placeholder="$attrs.placeholder || 'Nome e sobrenome'"
    :helper-message="
      $attrs.helperMessage || 'Digite igual está em seus documentos.'
    "
    validations="required|min:7|max:200|name|rgx:persona.info.name"
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'FullNameInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
